import React from "react";
import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DescriptionIcon from "@mui/icons-material/Description";
import { useNavigate } from "react-router-dom";

const EventCard = ({ event }) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        borderRadius: "16px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
        transition: "0.3s",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        "&:hover": {
          transform: "translateY(-6px)",
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        {/* Date Badge */}
        {/* Title */}
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          sx={{ marginBottom: 1 }}
        >
          {event.title}
        </Typography>

        <Box
          sx={{
            display: "inline-block",
            background: "#f3f3f3",
            px: 1.5,
            py: 0.5,
            borderRadius: "20px",
            fontSize: 12,
            mb: 1.5,
          }}
        >
          📅 {event.date}
        </Box>

        {/* Location */}
        <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
          <LocationOnIcon sx={{ fontSize: 16, color: "#777", mr: 0.5 }} />
          <Typography variant="body2" color="text.secondary">
            {event.location}
          </Typography>
        </Box>

        {/* Description */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 1,
            mb: 2,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {event.description}
        </Typography>

        {/* Button */}
        <Button
          onClick={() => navigate(`/events/${event.id}`)}
          fullWidth
          variant="contained"
          sx={{
            mt: "auto",
            backgroundColor: "#e86c2c",
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": {
              backgroundColor: "#d65b1f",
            },
          }}
        >
          View Details →
        </Button>
      </CardContent>
    </Card>
  );
};

export default EventCard;
